module.exports = __webpack_public_path__ + "img/rss.71648a38.svg";